import {Modal, Button, ButtonGroup, Table, Collapse, Fade} from 'react-bootstrap'
import {request} from '../../helpers/request'
import React from 'react'
import Icon from 'react-fa'
import {t} from '../../helpers/translate'
let config = require('config');

class FiremelonClaimDisclaimerComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title,
      body: this.props.body,
      checked: false,
      show: true
    }
  }

  close() {
    this.setState({
      checked: false,
      show: false
    });
    this.props.onClose();
  }

  toggleChecked() {
    this.setState({checked: !this.state.checked});
  }

  makeClaimCall() {
    const baseApi = config.default.api;
    const appId = this.props.getApplicationId();
    const method = 'GET';
    $.when(request(`${baseApi}/claimLink/${appId}`, method, null, this.processLink.bind(this))).done();
  }

  processLink(responseData, statusCode) {
    const magentaApi = config.default.magenta_login;

    if (statusCode == 200) {
      if (responseData.AccessLink !== undefined && responseData.APIKey !== undefined) {
        window.open(`${magentaApi}/${responseData.APIKey}/${responseData.AccessLink}`);  
        this.close();
      } else if (responseData.Message !== undefined) {
        this.close();
        this.props.showModal( t('Error'), responseData.Message);
      }
    } else {
      this.close();
      this.props.showModal( t('Error'), t('Unable to get application data'));
    }
  }

  render() {
    return <Modal className='disclaimer-confirmation-modal' show={this.state.show} onHide={this.close.bind(this)} backdrop={'static'}>
        <Modal.Header>
          <Modal.Title>{t(`${this.props.title}`)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div>
              {t(`${this.props.body}`)}
            </div>
            <br />
            <div>
              <input type="checkbox" onChange={this.toggleChecked.bind(this)}/>
             {t(' I agree')}
            </div>
        </Modal.Body>
        <Modal.Footer>
            <ButtonGroup>
              <button className="btn button-primary" onClick={this.close.bind(this)}>{t('Close')}</button>
              { 
                this.state.checked ?
                <button className="btn button-secondary" onClick={this.makeClaimCall.bind(this)}>{t('Continue')}</button>
                : null
              }
            </ButtonGroup>
        </Modal.Footer>
      </Modal>;
  }
}

FiremelonClaimDisclaimerComponent.displayName = 'FiremelonClaimDisclaimerComponent';
export default FiremelonClaimDisclaimerComponent;



// WEBPACK FOOTER //
// ./src/components/common/FiremelonClaimDisclaimerComponent.js